/**
  * 统计模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const SumApi = {
    GetSumData: `${base.qa}/AdminSum/GetSumData`,//平台统计概况
    GetChartSumData: `${base.qa}/AdminSum/GetChartSumData`,//根据实验类型或设备统计图
    GetHomeExperDataChart: `${base.qa}/AdminSum/GetHomeExperDataChart`,//首页实验统计图
    GetExperSumData: `${base.qa}/AdminSum/GetExperSumData`,//实验统计数据
    GetStepSumData: `${base.qa}/AdminSum/GetStepSumData`,//实验步骤数据
    GetExperTree: `${base.qa}/Experiment/GetExperTree`,//获取实验树形结构
    GetCouseStudyRecord: `${base.qa}/AdminSum/GetCouseStudyRecord`,//后台课程学习记录
    GetExperOperateRecord: `${base.qa}/AdminSum/GetExperOperateRecord`,//后台实验操作记录
    GetDataList: `${base.qa}/ExperOperateCheck/GetDataList`,//后台教师发布实验操作考核
    GetCheckRecordlist: `${base.qa}/AdminSum/GetCheckRecordlist`,//后台试题考核记录
    GetExamSumDataByClass: `${base.qa}/AdminSum/GetExamSumDataByClass`,//考核统计

    GetExperOperSteps: `${base.qa}/TeaSum/GetExperOperSteps`,//查询实验操作步骤
    GetExperCheckRport: `${base.qa}/TeaSum/GetExperCheckRport`,//查询实验报告
    GetTestEvaData: `${base.qa}/TeaStatis/GetTestEvaData`,//查询测评数据
    GetTestEvaDetail: `${base.qa}/TeaStatis/GetTestEvaDetail`,//查询测评详情

    GetExamQuestionCheckList: `${base.qa}/ExamQuestionCheck/GetExamQuestionCheckList`,//试题考核列表

    GetExperTree: `${base.qa}/Experiment/GetExperTree`,//实验树形结构

    GetClassExperSumData: `${base.qa}/AdminSum/GetClassExperSumData`,//查询班级实验数据
    ExportClassExperSumData: `${base.qa}/AdminSum/ExportClassExperSumData`,//导出班级实验数据
}

const Sum = {
    GetSumData () {
        return axios.get(SumApi.GetSumData)
    },
    GetChartSumData (type) {
        return axios.get(SumApi.GetChartSumData, { params: { type } })
    },
    GetHomeExperDataChart () {
        return axios.get(SumApi.GetHomeExperDataChart)
    },
    GetExperSumData (params) {
        let _newPar = {}
        for (const key in params) {
            if ((params[key] === 0 || params[key] === false || params[key]) && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
                _newPar[key] = params[key];
            }
        }
        return axios.get(SumApi.GetExperSumData, { params: { experimentid: _newPar.experimentid, classid: _newPar.classid } })
    },
    GetExperTree (params) {
        return axios.get(SumApi.GetExperTree)
    },
    GetStepSumData (experimentid) {
        return axios.get(SumApi.GetStepSumData, { params: { experimentid } })
    },
    GetCouseStudyRecord (params) {
        return axios.get(SumApi.GetCouseStudyRecord, { params })
    },
    GetExperOperateRecord (params) {
        return axios.get(SumApi.GetExperOperateRecord, { params })
    },
    GetDataList (params) {
        return axios.get(SumApi.GetDataList, { params })
    },
    GetCheckRecordlist (params) {
        return axios.get(SumApi.GetCheckRecordlist, { params })
    },

    GetExperOperSteps (operaterecordid) {
        return axios.get(SumApi.GetExperOperSteps, { params: { operaterecordid } })
    },
    GetExperCheckRport (operaterecordid) {
        return axios.get(SumApi.GetExperCheckRport, { params: { operaterecordid } })
    },
    GetExamSumDataByClass (params) {
        return axios.get(SumApi.GetExamSumDataByClass, { params: { examquestioncheckid: params.examquestioncheckid, classid: params.classid } })
    },
    GetTestEvaData (params) {
        return axios.get(SumApi.GetTestEvaData, { params: { classid: params.classid, experimentid: params.experimentid, pageindex: params.pageindex, pagesize: params.pagesize } })
    },
    GetTestEvaDetail (userid) {
        return axios.get(SumApi.GetTestEvaDetail, { params: { userid } })
    },

    GetExamQuestionCheckList (params) {
        return axios.get(SumApi.GetExamQuestionCheckList, { params })
    },
    GetExperTree (params) {
        return axios.get(SumApi.GetExperTree, { params })
    },
    GetClassExperSumData (params) {
        return axios.get(SumApi.GetClassExperSumData, { params })
    },
    ExportClassExperSumData (params) {
        return axios.get(SumApi.ExportClassExperSumData, { params })
    },
}


export default Sum;